export default __webpack_public_path__ + "static/media/flipper_license.e9f7ed9b.svg";